<template>
    <div class="mainBox">
        <div class="mainTop">
            <div class="fixed-text" @click="home">首页</div>
            <div style="color: white;font-size: 26px;font-weight: 700;">数据仓库看板</div>
            <div class="fixed-text" @click="logout">退出登录</div>
        </div>
        <div class="mainBottom">
            <div class="mbBox">
                <div class="mbbLeft">
                    <div ref="chartTen" class="styled-container" style="background-color:  rgb(255, 255, 255);">
                        <div class="title">
                            <p>安全运行天数</p>
                            <p class="days">374</p>
                        </div>
                        <div class="date-info">
                            <div class="date">2021-09-20</div>
                            <div class="day">星期三</div>

                        </div>
                    </div>
                    <div ref="chartEight"
                        style="background-color:  rgb(255, 255, 255);width: 100%; height:4.25rem;min-height: 340px;  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);margin-top: 5px;">
                    </div>
                    <div ref="chartThree"
                        style="background-color:  rgb(255, 255, 255);width: 100%; height:6rem;min-height: 480px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);margin-top: 5px;">
                    </div>


                </div>
                <div class="mbbCenter">
                    <leaflet-map />
                    <div style="display: flex;margin-top: 0.625rem;">
                        <div ref="chartFour"
                            style="flex: 1;height: 3.75rem;min-height: 300px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);margin-top: 5px;">
                        </div>
                        <div ref="chartFive"
                            style="flex:1;height: 3.75rem;min-height: 300px;box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);margin-top: 5px;">
                        </div>
                    </div>
                    <div style="display: flex;m">
                        <div ref="chartTwe"
                        style="flex: 1;height: 3.75rem;min-height: 300px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);margin-top: 5px;">
                    </div>
                    <div ref="chartSix"
                        style="flex: 1;height: 3.75rem;min-height: 300px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);margin-top: 5px;">
                    </div>
                    </div>

                    

                </div>
                <div class="mbbRight">
                    <div ref="chartNine" style="width: 100%; height: 5rem;min-height: 300px;   box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);">
                    </div>
                    <div ref="chartSeven"
                        style="width: 100%;height: 5rem;min-height: 300px;    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);margin-top: 5px;">
                    </div>
                    <div ref="chartOne"
                        style="width: 100%;height: 5rem;min-height: 300px;   box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);margin-top: 5px;">
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as echarts from 'echarts'
import LeafletMap from "@/components/map.vue";
import './macarons.js'
export default
    {
        data() {
            return {
                fullscreenLoading: false,
                loading: true, // 初始显示 loading 动画
                getTypeList:
                {
                    privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                    appIdentification: 'wms',
                    tableName: 'main_variable_maintenance'
                },
            }
        },
        components:
        {
            LeafletMap,
        },
        created() {
            this.openFullScreen1()
            this.getNumber()
        },
        methods:
        {
            openFullScreen1() {
                this.fullscreenLoading = true;
                setTimeout(() => {
                    this.fullscreenLoading = false;
                }, 2000);
            },
            init(number) {
                //地图预留
            },
            initOne() {
                //表格1
                const myChart = echarts.init(this.$refs.chartOne, 'macarons')
                const option =
                {

                    tooltip:
                    {
                        trigger: 'axis'
                    },
                    legend: {},
                    toolbox:
                    {
                        show: true,
                        feature:
                        {
                            dataZoom:
                            {
                                yAxisIndex: 'none'
                            },
                            dataView: { readOnly: false },
                            magicType: { type: ['line', 'bar'] },
                            restore: {},
                            saveAsImage: {}
                        }
                    },
                    xAxis:
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                    },
                    yAxis:
                    {
                        type: 'value',
                        axisLabel:
                        {
                            formatter: '{value} °C'
                        }
                    },
                    series: [
                        {
                            name: 'Highest',
                            type: 'line',
                            data: [10, 11, 13, 11, 12, 12, 9],
                            markPoint:
                            {
                                data: [
                                    { type: 'max', name: 'Max' },
                                    { type: 'min', name: 'Min' }
                                ]
                            },
                            markLine:
                            {
                                data: [{ type: 'average', name: 'Avg' }]
                            }
                        },
                        {
                            name: 'Lowest',
                            type: 'line',
                            data: [1, -2, 2, 5, 3, 2, 0],
                            markPoint:
                            {
                                data: [{ name: '周最低', value: -2, xAxis: 1, yAxis: -1.5 }]
                            },
                            markLine:
                            {
                                data: [
                                    { type: 'average', name: 'Avg' },
                                    [
                                        {
                                            symbol: 'none',
                                            x: '90%',
                                            yAxis: 'max'
                                        },
                                        {
                                            symbol: 'circle',
                                            label: {
                                                position: 'start',
                                                formatter: 'Max'
                                            },
                                            type: 'max',
                                            name: '最高点'
                                        }
                                    ]
                                ]
                            }
                        }
                    ]
                }
                myChart.setOption(option);
            },
            initTwo() {
                //表格2  
                const myChart = echarts.init(this.$refs.chartTwe, 'macarons')
                const option = {


                    toolbox: {
                        show: true,
                        feature: {
                            mark: { show: true },
                            dataView: { show: true, readOnly: false },
                            restore: { show: true },
                            saveAsImage: { show: true }
                        }
                    },
                    series: [
                        {
                            name: 'Nightingale Chart',
                            type: 'pie',
                            radius: ['10%', '60%'], // 修改半径
                            center: ['50%', '50%'], // 居中显示
                            roseType: 'area',
                            itemStyle: {
                                borderRadius: 8
                            },
                            data: [
                                { value: 40, name: 'rose 1' },
                                { value: 38, name: 'rose 2' },
                                { value: 32, name: 'rose 3' },
                                { value: 30, name: 'rose 4' },
                                { value: 28, name: 'rose 5' },
                                { value: 26, name: 'rose 6' },
                                { value: 22, name: 'rose 7' },
                                { value: 18, name: 'rose 8' }
                            ]
                        }
                    ]
                };

                myChart.setOption(option);



            },
            initThree() {
                const myChart = echarts.init(this.$refs.chartThree, 'macarons')
                const option = {
                    title: {

                        subtext: 'Fake Data'
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['Rainfall', 'Evaporation']
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            dataView: { show: true, readOnly: false },
                            magicType: { show: true, type: ['line', 'bar'] },
                            restore: { show: true },
                            saveAsImage: { show: true }
                        }
                    },
                    calculable: true,
                    xAxis: [
                        {
                            type: 'category',
                            // prettier-ignore
                            data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value'
                        }
                    ],
                    series: [
                        {
                            name: 'Rainfall',
                            type: 'bar',
                            data: [
                                2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3
                            ],
                            markPoint: {
                                data: [
                                    { type: 'max', name: 'Max' },
                                    { type: 'min', name: 'Min' }
                                ]
                            },
                            markLine: {
                                data: [{ type: 'average', name: 'Avg' }]
                            }
                        },
                        {
                            name: 'Evaporation',
                            type: 'bar',
                            data: [
                                2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3
                            ],
                            markPoint: {
                                data: [
                                    { name: 'Max', value: 182.2, xAxis: 7, yAxis: 183 },
                                    { name: 'Min', value: 2.3, xAxis: 11, yAxis: 3 }
                                ]
                            },
                            markLine: {
                                data: [{ type: 'average', name: 'Avg' }]
                            }
                        }
                    ]
                };

                myChart.setOption(option);

            },
            initFour() {
                const myChart = echarts.init(this.$refs.chartFour, 'macarons')
                const option = {
                    textStyle: {
                        fontSize: 7, // 设置字体大小为10
                        // 可以设置其他文字样式属性，如 fontFamily、fontWeight 等
                    },

                    radar: {
                        // shape: 'circle',
                        indicator: [
                            { name: 'Sales', max: 6500 },
                            { name: 'Administration', max: 16000 },
                            { name: 'Information Technology', max: 30000 },
                            { name: 'Customer Support', max: 38000 },
                            { name: 'Development', max: 52000 },
                            { name: 'Marketing', max: 25000 }
                        ]
                    },
                    series: [
                        {
                            name: 'Budget vs spending',
                            type: 'radar',
                            data: [
                                {
                                    value: [4200, 3000, 20000, 35000, 50000, 18000],
                                    name: 'Allocated Budget'
                                },
                                {
                                    value: [5000, 14000, 28000, 26000, 42000, 21000],
                                    name: 'Actual Spending'
                                }
                            ]
                        }
                    ]
                };
                myChart.setOption(option);
            },
            initFive() {
                const myChart = echarts.init(this.$refs.chartFive, 'macarons')
                const option = {
                    series: [
                        {
                            type: 'gauge',
                            axisLine: {
                                lineStyle: {
                                    width: 30,
                                    color: [
                                        [0.3, '#67e0e3'],
                                        [0.7, '#37a2da'],
                                        [1, '#fd666d']
                                    ]
                                }
                            },

                            pointer: {
                                itemStyle: {
                                    color: 'auto'
                                }
                            },
                            axisTick: {
                                distance: -30,
                                length: 8,
                                lineStyle: {
                                    color: '#fff',
                                    width: 1
                                }
                            },
                            splitLine: {
                                distance: -30,
                                length: 25,
                                lineStyle: {
                                    color: '#fff',
                                    width: 0.1
                                }
                            },
                            axisLabel: {
                                color: 'inherit',
                                distance: 40,
                                fontSize: 8
                            },
                            detail: {
                                valueAnimation: true,
                                formatter: '{value} km/h',
                                color: 'inherit',
                                fontSize: 8,
                            },
                            data: [
                                {
                                    value: 10
                                }
                            ]
                        }
                    ]
                };
                setInterval(function () {
                    myChart.setOption({
                        series: [
                            {
                                data: [
                                    {
                                        value: +(Math.random() * 100).toFixed(2)
                                    }
                                ]
                            }
                        ]
                    });
                }, 2000);

                myChart.setOption(option);
            },
            initSix() {
                const myChart = echarts.init(this.$refs.chartSix, 'macarons')
                const option = {
                    title: {

                        subtext: 'Fake Data',
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'item'
                    },

                    series: [
                        {
                            name: 'Access From',
                            type: 'pie',
                            radius: '50%',
                            data: [
                                { value: 1048, name: 'Search Engine' },
                                { value: 735, name: 'Direct' },
                                { value: 580, name: 'Email' },
                                { value: 484, name: 'Union Ads' },
                                { value: 300, name: 'Video Ads' }
                            ],
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                };
                myChart.setOption(option);

            },
            initSeven() {
                const myChart = echarts.init(this.$refs.chartSeven, 'macarons')
                const option = {
                    color: ['#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'],

                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    legend: {
                        data: ['Line 1', 'Line 2', 'Line 3', 'Line 4', 'Line 5']
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: {}
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'category',
                            boundaryGap: false,
                            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value'
                        }
                    ],
                    series: [
                        {
                            name: 'Line 1',
                            type: 'line',
                            stack: 'Total',
                            smooth: true,
                            lineStyle: {
                                width: 0
                            },
                            showSymbol: false,
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgb(128, 255, 165)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgb(1, 191, 236)'
                                    }
                                ])
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: [140, 232, 101, 264, 90, 340, 250]
                        },
                        {
                            name: 'Line 2',
                            type: 'line',
                            stack: 'Total',
                            smooth: true,
                            lineStyle: {
                                width: 0
                            },
                            showSymbol: false,
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgb(0, 221, 255)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgb(77, 119, 255)'
                                    }
                                ])
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: [120, 282, 111, 234, 220, 340, 310]
                        },
                        {
                            name: 'Line 3',
                            type: 'line',
                            stack: 'Total',
                            smooth: true,
                            lineStyle: {
                                width: 0
                            },
                            showSymbol: false,
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgb(55, 162, 255)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgb(116, 21, 219)'
                                    }
                                ])
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: [320, 132, 201, 334, 190, 130, 220]
                        },
                        {
                            name: 'Line 4',
                            type: 'line',
                            stack: 'Total',
                            smooth: true,
                            lineStyle: {
                                width: 0
                            },
                            showSymbol: false,
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgb(255, 0, 135)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgb(135, 0, 157)'
                                    }
                                ])
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: [220, 402, 231, 134, 190, 230, 120]
                        },
                        {
                            name: 'Line 5',
                            type: 'line',
                            stack: 'Total',
                            smooth: true,
                            lineStyle: {
                                width: 0
                            },
                            showSymbol: false,
                            label: {
                                show: true,
                                position: 'top'
                            },
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgb(255, 191, 0)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgb(224, 62, 76)'
                                    }
                                ])
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: [220, 302, 181, 234, 210, 290, 150]
                        }
                    ]
                };
                myChart.setOption(option);

            },
            initEight() {
                const myChart = echarts.init(this.$refs.chartEight, 'macarons')
                const option = {

                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c}%'
                    },

                    legend: {
                        data: ['Show', 'Click', 'Visit', 'Inquiry', 'Order']
                    },
                    series: [
                        {
                            name: 'Funnel',
                            type: 'funnel',
                            left: '10%',
                            top: 60,
                            bottom: 60,
                            width: '80%',
                            min: 0,
                            max: 100,
                            minSize: '0%',
                            maxSize: '100%',
                            sort: 'descending',
                            gap: 5,
                            label: {
                                show: false,
                                position: 'inside'
                            },


                            data: [
                                { value: 60, name: 'Visit' },
                                { value: 40, name: 'Inquiry' },
                                { value: 20, name: 'Order' },
                                { value: 80, name: 'Click' },
                                { value: 100, name: 'Show' }
                            ]
                        }
                    ]
                };
                myChart.setOption(option);
            },
            initNine() {
                const myChart = echarts.init(this.$refs.chartNine, 'macarons')
                const option = {

                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    legend: {},
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        boundaryGap: [0, 0.01]
                    },
                    yAxis: {
                        type: 'category',
                        data: ['Brazil', 'Indonesia', 'USA', 'India', 'China', 'World']
                    },
                    series: [
                        {
                            name: '2011',
                            type: 'bar',
                            data: [18203, 23489, 29034, 104970, 131744, 630230]
                        },
                        {
                            name: '2012',
                            type: 'bar',
                            data: [19325, 23438, 31000, 121594, 134141, 681807]
                        }
                    ]
                };

                myChart.setOption(option);
            },
            // 调用接口获取图表数据
            async getNumber() {
                let params = new URLSearchParams();
                // if (!this.inquireList.number01) return this.$message.error('请选择查询条件！')
                params.append("privateKey", this.getTypeList.privateKey)
                params.append("appIdentification", this.getTypeList.appIdentification)
                params.append("ID", window.sessionStorage.getItem("token"))
                const { data: res } = await this.$http.get('/User/SelectUserLog', { params })
                this.SysCount = res.SysCount
                this.StrogeCount = res.StrogeCount
                this.init(res)
                this.initOne()
                this.initTwo()
                this.initThree()
                this.initFour()
                this.initFive()
                this.initSix()
                this.initSeven()
                this.initEight()
                this.initNine()
            },
            home() {
                this.$router.push("/common")
            },
            logout() {

                window.sessionStorage.clear()
                this.$router.push("/login")

            },
        }
    }
</script>
<style lang="less" scoped>
.mainBox {
    .mainTop {
        background-color: rgb(37, 83, 153);
        height: 1.0875rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        box-sizing: border-box;

        .fixed-text {
            color: #fff;
            /* 文字颜色 */
            font-size: 15px;
            cursor: pointer;
        }
    }

    .mainBottom {
        padding: 10px;

        .mbBox {
            display: flex;

            .mbbLeft {
                flex: 1;

                // background-color: pink;
                .styled-container {

                    padding: 20px;
                    box-sizing: border-box;
                    text-align: center;

                    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
                    font-family: Arial, sans-serif;
                }

                .title {
                    font-size: 50px;
                    font-weight: bold;
                    color: #333;
                }

                .days {
                    font-size: 40px;
                    color: #0572e6;
                }

                .date-info {
                    margin-top: 20px;
                }

                .date,
                .day,
                .time {
                    display: inline-block;
                    margin-right: 10px;
                    font-size: 30px;
                    color: #555;
                }
            }

            .mbbCenter {
                flex: 1;
                // background-color: red;
                margin-left: 10px;
                margin-right: 10px;
            }

            .mbbRight {
                flex: 1;
                // background-color: green;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }
        }
    }
}
</style>